<template>
    <v-app>
        <template v-if="authorized">
            <top-bar></top-bar>
            <v-content class="light-grey-bg">
                <router-view></router-view>
            </v-content>
        </template>
        <template v-else>
            <v-content class="primary-bg">
                <router-view></router-view>
            </v-content>
        </template>
    </v-app>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import TopBar from '../src/components/_layouts/TopBar'
    export default {
        name: 'App',
        data: () => ({
            searchBarActive: false
        }),
        components: {
            TopBar
        },
        mounted () {
            this.authorized && this.sessionCheck()
        },
        watch: {},
        methods: {
            ...mapActions({
                sessionCheck: 'auth/sessionCheck'
            })
        },
        computed: {
            ...mapGetters({
                authorized: 'auth/isAuthorized'
            })
        }
    }
</script>
<style>
    .primary-bg {
        background-color: #00A5C5;
    }
    .light-grey-bg {
        background-color:white;
    }
    .title-block {
        color: #fff;
    }
</style>
